import { Heart } from "lucide-react";

const Footer = () => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="footer"
      className="bg-[#442F23] text-[#FBF8E9] py-16"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-2xl font-semibold text-[#FBF8E9] mb-4">
              Light Workers House
            </h3>
            <p className="font-body text-sm text-[#FBF8E9]/50 leading-relaxed mb-6">
              La casa dei Guerrieri di Luce.
              <br />
              Percorsi di crescita e luce interiore.
            </p>
            {/* Social icons */}
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/stella_soul_coach/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#FBF8E9]/10 flex items-center justify-center hover:bg-[#E1C340]/20 transition-colors"
                data-testid="social-instagram"
                aria-label="Instagram"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              </a>
              <a
                href="https://www.facebook.com/alessia.stella.397/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#FBF8E9]/10 flex items-center justify-center hover:bg-[#E1C340]/20 transition-colors"
                data-testid="social-facebook"
                aria-label="Facebook"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
              </a>
              <a
                href="https://t.me/+Yw8T5GX-wq5iMjFk"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#FBF8E9]/10 flex items-center justify-center hover:bg-[#E1C340]/20 transition-colors"
                data-testid="social-telegram"
                aria-label="Telegram - Viaggio di Luce"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.198 2.433a2.242 2.242 0 0 0-1.022.215l-8.609 3.33c-2.068.8-4.133 1.598-5.724 2.21a405.15 405.15 0 0 1-2.849 1.09c-.42.147-.99.332-1.473.901-.728.855.058 1.665.478 1.979.418.312 2.455 1.399 2.455 1.399l.005.003 4.299 1.666s.096.193.159.32c.016.031.035.067.055.103a.71.71 0 0 0 .098.159l-.007-.006 1.61 4.376s.243.658.825.681a.87.87 0 0 0 .054.002c.39 0 .76-.246.76-.246l.01-.006 2.64-2.408 3.925 3.283s.482.38 1.063.389c.582.008 1.116-.385 1.116-.385a1.85 1.85 0 0 0 .518-.712l.005-.01c.075-.18.106-.29.106-.29l2.725-14.076.004-.018c.088-.424.162-.8.096-1.175a1.59 1.59 0 0 0-1.523-1.28z"/></svg>
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-body text-sm font-semibold text-[#FBF8E9]/80 uppercase tracking-wider mb-6">
              Navigazione
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Membership", id: "membership" },
                { label: "Chi sono", id: "chi-sono" },
                { label: "Testimonianze", id: "testimonianze" },
                { label: "Prezzi", id: "pricing-section" },
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="font-body text-sm text-[#FBF8E9]/50 hover:text-[#E1C340] transition-colors"
                    data-testid={`footer-link-${link.id}`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body text-sm font-semibold text-[#FBF8E9]/80 uppercase tracking-wider mb-6">
              Contatti
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:info@stellasoulcoach.com"
                  className="font-body text-sm text-[#FBF8E9]/50 hover:text-[#E1C340] transition-colors"
                  data-testid="footer-email"
                >
                  info@stellasoulcoach.com
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/stellasoulcoach"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-body text-sm text-[#FBF8E9]/50 hover:text-[#E1C340] transition-colors"
                  data-testid="footer-telegram"
                >
                  Telegram: @stellasoulcoach
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#FBF8E9]/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-xs text-[#FBF8E9]/30">
            &copy; {new Date().getFullYear()} Light Workers House. Tutti i diritti riservati.
          </p>
          <p className="font-body text-xs text-[#FBF8E9]/30 flex items-center gap-1">
            Fatto con <Heart size={12} className="text-[#E1C340]" /> da Stella Soul Coach
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
